import { useSelector } from 'react-redux';

// Types
import { Organization } from 'Shared/types/Organization.type';

export const useOrganization = () => {
  const organization = useSelector((state: { organization: Organization }) => state.organization);
  const isPiOrganization = Boolean(organization?.pi_company_guid);
  const isPiDemoAccount = organization?.is_pi_demo_account;
  const companyGuid = organization?.pi_company_guid;
  const billingState = organization?.billingState;
  const features = organization.features;

  return { organization, isPiOrganization, isPiDemoAccount, companyGuid, billingState, features };
};
